exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".charts .tabs-container[data-v-3bd74f6c] {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin: 5px 0;\n}\n.charts .chart-container[data-v-3bd74f6c] {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
